//Margin conventions
var margin = {top: 10, right: 59, bottom: 5, left: 136};

var widther = d3.select(".gia-chart").node().clientWidth;

var width = widther - margin.left - margin.right,
    height = 300 - margin.top - margin.bottom;

//Appends the svg to the chart-container div
var svg = d3.select(".gia-chart").append("svg")
  .attr("width", width + margin.left + margin.right)
  .attr("height", height + margin.top + margin.bottom)
  .append("g")
  .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

//Format comma
var format = d3.format("0,000")

//Creates the xScale 
var xScale = d3.scale.linear()
  .range([0,width]);

//Creates the yScale
var y0 = d3.scale.ordinal()
  .rangeBands([height, 0], 0.2)
  .domain(["Forehead lift", "Neck lift", "Dermabrasion", "Breast lift", "Tummy tuck", "Facelift", "Eyelid surgery", "Nose reshaping", "Liposuction", "Breast augmentation"]);

//Defines the y axis styles
var yAxis = d3.svg.axis()
  .scale(y0)
  .tickSize(-width)
  .tickPadding(6)
  .ticks(4)
  .orient("left");


//Defines the y axis styles
var xAxis = d3.svg.axis()
  .scale(xScale)
  .tickPadding(6)
  .orient("bottom")
  .ticks(6); 

//Loads the data
d3.csv("data/surgery.csv", ready);

function ready(err, data) {

  if (err) throw "error loading data";

  //FORMAT data
  data.forEach(function(d) {
    d.count = +d.count;
  });

//Sets the max for the xScale
  var maxX = d3.max(data, function(d) { return d.count; });

  //Defines the xScale max
  xScale.domain([0, maxX]);

  //Appends the y axis
  var yAxisGroup = svg.append("g")
    .attr("class", "y axis")
    .call(yAxis);

  d3.selectAll(".y.axis text")
      .attr("transform", "translate(-131, 0)");   

  //Appends the x axis    
  var xAxisGroup = svg.append("g")
    .attr("class", "x axis")
    .call(xAxis); 

  //Binds the data to the bars      
  var categoryGroup = svg.selectAll(".g-category-group")
    .data(data)
    .enter()
    .append("g")
    .attr("class", "g-category-group")
    .attr("transform", function(d) {
      return "translate(0," + y0(d.surgery) + ")";
    });

  //Appends first bar   
  var bars = categoryGroup.append("rect")
    .attr("width", function(d) { return xScale(d.count); })
    .attr("height", y0.rangeBand()/1.1)
    .attr("class", "bars")
    .attr("transform", "translate(0,2)");

  //Binds data to labels
  var labelGroup = svg.selectAll("g-num")
    .data(data)
    .enter()
    .append("g")
    .attr("class", "g-label-group")
    .attr("transform", function(d) {
      return "translate(0," + y0(d.surgery) + ")";
    });

  //Appends first bar labels   
  var barLabels = labelGroup.append("text") 
    .text(function(d) {return  format(d.count);})
    .attr("x", function(d) { return xScale(d.count) + 5; })
    .attr("y", y0.rangeBand()/1.4)
    .attr("class", "g-labels");    

//RESPONSIVENESS
  d3.select(window).on("resize", resized);

  function resized() {

    //new margin
    var newMargin = {top: 10, right: 59, bottom: 5, left: 136};

    var newWidther = d3.select(".gia-chart").node().clientWidth;

    var newWidth = newWidther - newMargin.left - newMargin.right;

    //Change the width of the svg
    d3.select("svg")
      .attr("width", newWidth + newMargin.left + newMargin.right);

    //Change the xScale
    xScale
      .range([0, newWidth]);

    //Update the bars
    bars
      .attr("width", function(d) { return xScale(d.count); });

    //Updates bar labels
    barLabels
      .attr("x", function(d) { return xScale(d.count) + 5; })
      .attr("y", y0.rangeBand()/1.4 )

    //Updates xAxis
    d3.selectAll(".x.axis")
         .call(xAxis);     

    //Updates ticks
    xAxis
      .scale(xScale)
      .ticks(6);

    //Updates yAxis
    d3.selectAll(".y.axis")
      .call(yAxis); 

    yAxis
      .tickSize(-newWidth);

  };

}